import React from 'react';
import { AlertTriangle, Mail } from 'lucide-react';
import { footerCols, CONTACT_EMAIL, socialLinks } from '../mock';
import VisualLogoMark from './VisualLogoMark';
import './VisualHomepage.css';

// Same footer shell as the homepage (dark visual theme), keeping the
// subpages' link columns, contact, notice, and copyright.
const Footer = () => (
  <footer className="visual-footer--page">
    <div className="visual-footer__inner">
      <div className="visual-footer__top">
        <div>
          <div className="visual-footer__brand">
            <VisualLogoMark compact />
            <strong>Tangibl3Net</strong>
            <span>Institutional infrastructure</span>
          </div>
          <p className="visual-footer__desc">
            Tangibl3Net is a platform for compliant asset tokenization, helping issuers turn documented assets into controlled digital tokens with clear records, issuer workflows, and compliance guardrails.
          </p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="visual-footer__contact">
            <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
          </a>
          <div className="visual-footer__social">
            {socialLinks.map(({ label, href }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer">{label}</a>
            ))}
          </div>
        </div>
        {footerCols.map((col) => (
          <div key={col.title}>
            <h4>{col.title}</h4>
            <ul>
              {col.links.map((link) => (
                <li key={link.label}><a href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="visual-footer__notice">
        <AlertTriangle className="w-4 h-4" />
        <span>
          <strong>Notice:</strong> Tangibl3Net provides compliant asset tokenization infrastructure, verification workflows, wallet coordination, recordkeeping, restricted transfer controls, OTC request support where permitted, redemption workflow coordination, and business development visibility. Tangibl3Net does not guarantee liquidity, listing, trading volume, redemption performance, legal classification, regulatory approval, asset value, investor demand, token price, repayment, or investment returns.
        </span>
      </div>
      <p className="visual-footer__copyright">© 2026 Tangibl3Net. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
